import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { SecuritiesChartSelectedType } from "./types";

const Container = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-left: ${({ theme }) => theme.spacing(2)};
  ${({ theme }) => theme.breakpoints.down("sm")} {
    margin-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;

const CheckboxLabelContent = styled("span")`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const ColorDot = styled("span")<{ color?: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ theme, color }) => color || theme.palette.divider};
`;

export interface ChartControlItem {
  text: string;
  value: SecuritiesChartSelectedType;
  clickable?: boolean;
}

interface Props {
  chartControl: ChartControlItem[];
  selectedTypes: SecuritiesChartSelectedType[];
  onToggleType: (value: SecuritiesChartSelectedType) => void;
  chartColors: Record<string, string>;
  hasMultipleAssetTypes: boolean;
}

export const AssetTypeSelector = ({
  chartControl,
  selectedTypes,
  onToggleType,
  chartColors,
  hasMultipleAssetTypes,
}: Props) => {
  if (!hasMultipleAssetTypes) {
    return null;
  }

  return (
    <Container>
      {chartControl.map((type) => {
        const checked = selectedTypes.includes(type.value);
        const color = chartColors[type.value];

        return (
          <FormControlLabel
            key={`filter-${type.value}`}
            control={
              <Checkbox
                size="small"
                checked={checked}
                onChange={() => type.clickable && onToggleType(type.value)}
              />
            }
            label={
              <CheckboxLabelContent>
                <ColorDot color={color} />
                <Typography variant="body3">{type.text}</Typography>
              </CheckboxLabelContent>
            }
          />
        );
      })}
    </Container>
  );
};
